export default __webpack_public_path__ + "static/la-splendeur-au-lieu-des-cendres-announcement-bg-29006856a186d1a5a93f7d0f8e2c4b99.webp";